import styled from 'styled-components';

const DisableOverlay = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: #000000e8;
    z-index: 100000;
    cursor: not-allowed;
`;

export default DisableOverlay;



// WEBPACK FOOTER //
// ./src/components/atoms/DisableOverlay.js